
const subscriptionTypes = {
  SET_PLAN_SUBSCRIPTIONS_LIST: 'SET_PLAN_SUBSCRIPTIONS_LIST',
};
export default subscriptionTypes;